import { Snapsnap } from '@photocreate/snapsnap-api'
import { APIRequest } from '@/infra/network/APIRequest'
import { HTTPMethod } from '@/infra/network/types'

export class GetCreditCardInfo implements APIRequest<Snapsnap.Credit.GetCreditCardInfoResponse> {
  response: Snapsnap.Credit.GetCreditCardInfoResponse
  path = '/credit'
  method = HTTPMethod.GET
}

export class DeleteCreditCardInfo implements APIRequest<Snapsnap.Credit.DeleteCreditCardInfoResponse> {
  response: Snapsnap.Credit.DeleteCreditCardInfoResponse
  path = '/credit/delete_all'
  method = HTTPMethod.DELETE
}

export class SaveCreditCardInfo implements APIRequest<Snapsnap.Credit.SaveCreditCardInfoResponse> {
  response: Snapsnap.Credit.SaveCreditCardInfoResponse
  path = '/credit/save'
  method = HTTPMethod.POST
  params: Snapsnap.Credit.SaveCreditCardInfoRequest

  constructor(creditToken: string, ctx?: string) {
    this.params = {
      credit_token: creditToken,
      ctx: ctx || undefined
    }
  }
}
